import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    hideAll: {
        display: "none !important",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",

        width: "100%",
        background: theme.palette.primary.main,
    },
    dropzoneRenderArea: {
        width: "100%",
    },
    dropzone: {
        padding: "24px 16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        border: `1px dashed ${theme.palette.corporateBO.lineSeparator}`,
        borderRadius: 4,
    },
    iconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 48,
        height: 48,
        borderRadius: "100%",
        backgroundColor: theme.palette.secondary.main,
    },
    icon: {
        color: theme.palette.info.light,
    },
    text: {
        fontSize: 16,
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
    spanText: {
        color: theme.palette.info.light,
        textDecoration: "underline",
        cursor: "pointer",
    },
    fileList: {
        display: "flex",
        flexDirection: "column",
        marginTop: 16,
        width: "100%",
    },
    fileListWrapper: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        gap: 8,
    },
    fileDescription: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    fileTitle: {
        fontSize: 16,
        fontWeight: 400,
        color: theme.palette.text.primary,
    },
    fileSubtitle: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.text.secondary,
    },
    titleContainer: {
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        marginBottom: 16,
    },
    formSubtitle: {
        fontFamily: "Source Sans 3",
        fontWeight: 600,
        fontSize: "20px",
        color: theme.palette.secondary.dark,
        margin: "0",
    },
    previewWrapper: {
        marginTop: 32,
        width: "100%",
    },
    previewContainer: {
        width: "100%",
        height: 300,
    },
    preview: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
    },
    hintText: {
        fontSize: 14,
        fontWeight: 400,
        color: theme.palette.corporateBO.checkbox,
        marginTop: 8,
        textAlign: "center",
        display: "block",
    },
}));
